import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AwsIcon from '../../assets/icons/amazon-web-services.png';
import ArubaIcon from '../../assets/icons/aruba.png';
import F5Icon from '../../assets/icons/f5.png';
import HewlletIcon from '../../assets/icons/hewlett.png';
import Rainforest from '../../assets/icons/rainforest-badge.png';
import VmwareIcon from '../../assets/icons/vmware.png';
import AwsBanner from '../../assets/images/aws_banner.png';
import DecatronBanner from '../../assets/images/banner_30_anos.jpg';
import BannerCertigov from '../../assets/images/banner_certigov.png';
import Banner from '../../components/Banner/Banner';
import Card from '../../components/Card/Card';
import CTAButton from '../../components/CTAButton/CTAButton';
import FaleConosco from '../../components/FaleConosco/FaleConosco';
import Hero from '../../components/Hero/Hero';
import HeroStyles from '../../components/Hero/Hero.module.scss';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import Section from '../../components/Section/Section';
import { API_NEWS_URL } from '../../constants';
import { casesContents, ICaseContent } from '../../data/cases';
import { fadeInUp, scaleIn, staggerContainer, staggerItem } from '../../hooks/useScrollReveal';
import { AxiosHttp } from '../../services/axiosService';
import { notify } from '../../services/toastService';
import styles from './Home.module.scss';

const banners = [AwsBanner, DecatronBanner, BannerCertigov];

type ContentNewsType = {
    title: string;
    url: string;
    summary: string;
    publised_at: string;
    author: string;
};
interface INewsResponse {
    icon: string;
    vehicle_name: string;
    url: string;
    content: Array<ContentNewsType>;
}

interface IResponse {
    statusCode: number;
    body: INewsResponse[];
}

export default function Home() {
    const navigate = useNavigate();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [news, setNews] = useState<INewsResponse[]>([]);

    const succesReducer = Object.entries(casesContents).reduce<
        ICaseContent[]
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    >((acc, [key, value]) => [...acc, { ...value, sucessName: key }], []);

    useEffect(() => {
        const getNews = async (): Promise<void> => {
            try {
                const newsRequest = new AxiosHttp(API_NEWS_URL);
                const response = await newsRequest.get<IResponse>('api/get-news');
                if (response?.body) {
                    setNews(response?.body);
                }
            } catch (err) {
                notify.error(`Impossível Buscar Notícias: ${String(err)}`);
                console.log(err);
            }
        };
        void getNews();
    }, []);

    const handleNavigateToServices = () => {
        void navigate('/servicos');
    };

    const handleNavigateToContact = () => {
        void navigate('/contato');
    };

    const ArrowIcon = () => (
        <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
        >
            <path d="M7 17L17 7M17 7H7M17 7V17" />
        </svg>
    );

    return (
        <>
            <main className={styles.main}>
                <div className={styles.home_container}>
                    {/* Hero Section */}
                    <div className={styles.banner_container}>
                        <Banner itemsToRender={banners} />
                    </div>

                    <Hero
                        title="Transformando Negócios com Tecnologia"
                        description="Há 30 anos oferecendo soluções tecnológicas inovadoras para empresas que buscam excelência e crescimento sustentável."
                        customClass={HeroStyles.hero_home}
                    >
                        <div className={styles.hero_actions}>
                            <CTAButton
                                variant="primary"
                                size="lg"
                                onClick={handleNavigateToServices}
                                icon={<ArrowIcon />}
                            >
                                Conheça Nossas Soluções
                            </CTAButton>
                            <CTAButton variant="hero" size="lg" onClick={handleNavigateToContact}>
                                Fale Conosco
                            </CTAButton>
                        </div>
                    </Hero>

                    {/* Stats Section */}
                    <Section background="white" padding="lg">
                        <motion.div
                            className={styles.stats_grid}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.3 }}
                            variants={staggerContainer}
                        >
                            <motion.div className={styles.stat_item} variants={staggerItem}>
                                <h3 className={styles.stat_number}>30+</h3>
                                <p className={styles.stat_label}>Anos de Experiência</p>
                            </motion.div>
                            <motion.div className={styles.stat_item} variants={staggerItem}>
                                <h3 className={styles.stat_number}>290+</h3>
                                <p className={styles.stat_label}>Clientes Atendidos</p>
                            </motion.div>
                            <motion.div className={styles.stat_item} variants={staggerItem}>
                                <h3 className={styles.stat_number}>1350+</h3>
                                <p className={styles.stat_label}>Contratos Concluídos</p>
                            </motion.div>
                            <motion.div className={styles.stat_item} variants={staggerItem}>
                                <h3 className={styles.stat_number}>24/7</h3>
                                <p className={styles.stat_label}>Suporte Técnico</p>
                            </motion.div>
                        </motion.div>
                    </Section>

                    {/* Success Cases Section */}
                    <Section
                        background="gray"
                        padding="lg"
                        title="Casos de Sucesso"
                        subtitle="Conheça como ajudamos empresas a transformar seus negócios"
                    >
                        <motion.div
                            className={styles.cases_grid}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.2 }}
                            variants={staggerContainer}
                        >
                            {succesReducer.map((item, index) => (
                                <motion.div key={index} variants={staggerItem}>
                                    <Card
                                        title={item.title}
                                        description={item.resumo}
                                        sucess={item.sucessName}
                                    />
                                    {/* <div className={styles.case_content}>
                                        <h3 className={styles.case_title}>{item.title}</h3>
                                        <p className={styles.case_description}>{item.resumo}</p>
                                        <CTAButton
                                            variant="primary"
                                            size="md"
                                            onClick={() => handleNavigateToCase(item.sucessName)}
                                            icon={<ArrowIcon />}
                                        >
                                            Saiba Mais
                                        </CTAButton>
                                    </div> */}
                                </motion.div>
                            ))}
                        </motion.div>
                    </Section>

                    {/* Partners Section */}
                    <Section
                        background="white"
                        padding="lg"
                        title="Parceiros Estratégicos"
                        subtitle="Trabalhamos com as melhores tecnologias do mercado"
                    >
                        <motion.div
                            className={styles.partners_grid}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.3 }}
                            variants={staggerContainer}
                        >
                            <motion.div className={styles.partner_logo} variants={scaleIn}>
                                <img src={AwsIcon} alt="AWS" />
                            </motion.div>
                            <motion.div className={styles.partner_logo} variants={scaleIn}>
                                <img src={HewlletIcon} alt="Hewlett Packard Enterprise" />
                            </motion.div>
                            <motion.div className={styles.partner_logo} variants={scaleIn}>
                                <img src={VmwareIcon} alt="VMware" />
                            </motion.div>
                            <motion.div className={styles.partner_logo} variants={scaleIn}>
                                <img src={ArubaIcon} alt="Aruba" />
                            </motion.div>
                            <motion.div className={styles.partner_logo} variants={scaleIn}>
                                <img src={F5Icon} alt="F5" />
                            </motion.div>
                            <motion.div className={styles.partner_logo} variants={scaleIn}>
                                <img src={Rainforest} alt="Rainforest Badge" />
                            </motion.div>
                        </motion.div>
                    </Section>

                    {/* News Section */}
                    <Section
                        background="white"
                        padding="lg"
                        title="Últimas Notícias"
                        subtitle="Acompanhe as principais novidades do setor"
                    >
                        {!news.length ? (
                            <div className={styles.loading_container}>
                                <LoadingSpinner />
                            </div>
                        ) : (
                            <motion.div
                                className={styles.news_grid}
                                // initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.2 }}
                                variants={staggerContainer}
                            >
                                {news?.map((news_item, newsIndex) =>
                                    news_item.content.map((news_content, contentIndex) => (
                                        <article
                                            key={`${newsIndex}-${contentIndex}`}
                                            className={styles.news_card}
                                        >
                                            <div className={styles.news_content}>
                                                <h3 className={styles.news_title}>
                                                    {news_content.title}
                                                </h3>
                                                <p className={styles.news_summary}>
                                                    {news_content.summary}
                                                </p>

                                                <div className={styles.news_meta}>
                                                    <div className={styles.news_source}>
                                                        <span className={styles.source_label}>
                                                            Fonte:
                                                        </span>
                                                        <span className={styles.source_name}>
                                                            {news_item.vehicle_name}
                                                        </span>
                                                    </div>
                                                    <a
                                                        href={news_content.url}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        className={styles.news_link}
                                                    >
                                                        Ler mais
                                                        <ArrowIcon />
                                                    </a>
                                                </div>
                                            </div>
                                        </article>
                                    ))
                                )}
                            </motion.div>
                        )}
                    </Section>

                    {/* Contact Section */}
                    <Section background="white" padding="lg">
                        <motion.div
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.3 }}
                            variants={fadeInUp}
                        >
                            <FaleConosco />
                        </motion.div>
                    </Section>
                </div>
            </main>
        </>
    );
}
